import ClientService from '../../../services/client-service';
import saveTableColumnSettingsMutation from '../../../graphql/mutation/save-user-columns-settings.graphql';
import saveWidgetSettingsMutation from '../../../graphql/mutation/save-widget-settings.graphql';

export default class ControlsApi {
  public static saveTableColumnSettings(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(saveTableColumnSettingsMutation, payload);
  }

  public static saveWidgetSettings(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(saveWidgetSettingsMutation, payload);
  }
}
